import React, { useEffect, useState, useRef } from "react";
import './JobSelection.css'
import CloseIcon from '@mui/icons-material/Close';
import { Button } from "@mui/material";
import Box from '@mui/material/Box';
import Grid from '@mui/material/Grid2';
import Zoom from '@mui/material/Zoom';

function JobSelection(props) {

    const [trigger, setTrigger] = useState(false)

    const roles = ['Tank', 'Healer', 'DPS'];
    const tanks = ['DarkKnight', 'Gunbreaker', 'Paladin', 'Warrior']
    const healers = ['Astrologian', 'Sage', 'Scholar', 'WhiteMage']
    const melees = ['Dragoon', 'Monk', 'Ninja', 'Reaper', 'Samurai', 'Viper']
    const casters = ['BlackMage', 'Pictomancer', 'RedMage', 'Summoner']
    const ranged = ['Bard', 'Dancer', 'Machinist']

    let popup = document.querySelector(".popup");

    function jobSelector() {
        setTrigger(!trigger);
    }

    function close() {
        setTrigger(false);
    }

    function closePopup() {
        setTrigger(false);
    }

    function test(e) {
        e.cancelBubble = true;
        if (e.stopPropagation) e.stopPropagation();
    }

    function selectJob(job) {
        var role = "";
        if (job == 'Tank' || tanks.includes(job))
            role = "tank"
        else if (job == 'Healer' || healers.includes(job))
            role = "healer"
        else if (job == 'DPS' || melees.includes(job) || casters.includes(job) || ranged.includes(job))
            role = "dps"
        props.selectedJob(job, role)
        close();
    }

    function renderJobs(role) {
        if (role === "Tank") {
            return (
                <div>
                    {tanks.map((job) =>
                        <input key={`${job}`} onClick={() => selectJob(job)} type='image' src={require(`../FFXIVIcons/JOBS/${job}.png`)} style={{ width: '50px', float: 'center' }} />
                    )}
                </div>
            )
        }
        if (role === "Healer") {
            return (
                <div>
                    {healers.map((job) =>
                        <input key={`${job}`} onClick={() => selectJob(job)} type='image' src={require(`../FFXIVIcons/JOBS/${job}.png`)} style={{ width: '50px', float: 'center' }} />
                    )}
                </div>
            )
        }
        if (role === "DPS") {
            return (
                <div>
                    <div>
                        {melees.map((job) =>
                            <input key={`${job}`} onClick={() => selectJob(job)} type='image' src={require(`../FFXIVIcons/JOBS/${job}.png`)} style={{ width: '50px', float: 'center' }} />
                        )}
                    </div>
                    <div>
                        {casters.map((job) =>
                            <input key={`${job}`} onClick={() => selectJob(job)} type='image' src={require(`../FFXIVIcons/JOBS/${job}.png`)} style={{ width: '50px', float: 'center' }} />
                        )}
                    </div>
                    <div>
                        {ranged.map((job) =>
                            <input key={`${job}`} onClick={() => selectJob(job)} type='image' src={require(`../FFXIVIcons/JOBS/${job}.png`)} style={{ width: '50px', float: 'center' }} />
                        )}
                    </div>
                </div>
            )
        }
    }

    function jobPanel() {
        return (
            <div style={{ margin: '10px' }}>
                <Box sx={{ flexGrow: 1 }}>
                    <Grid container spacing={2}>

                        <Grid size={2} container spacing={0.5}>
                            <input onClick={() => selectJob('Tank')} type='image' src={require(`../FFXIVIcons/JOBS/Tank.png`)} style={{ width: '50px', height: '50px', marginBottom: '25px' }} />
                            {renderJobs('Tank')}
                        </Grid>
                        <Grid size={2} container spacing={0.5}>
                            <input onClick={() => selectJob('Healer')} type='image' src={require(`../FFXIVIcons/JOBS/Healer.png`)} style={{ width: '50px', height: '50px', marginBottom: '25px' }} />
                            {renderJobs('Healer')}
                        </Grid>

                        <Grid size={8} container spacing={0.5}>
                            <input onClick={() => selectJob('DPS')} type='image' src={require(`../FFXIVIcons/JOBS/DPS.png`)} style={{ width: '50px', height: '50px', marginBottom: '25px' }} />
                            {renderJobs('DPS')}
                        </Grid>

                    </Grid>
                </Box>

            </div >
        )
    }

    return (
        <div>
            <input onClick={jobSelector} type='image' src={require(`../FFXIVIcons/JOBS/${props.job}.png`)} style={{ width: '50px' }} />
            <Zoom in={trigger}>
                <div className="popup" onClick={closePopup}>
                    <div className='outer'>
                        <div className="popup-inner" onClick={test} >
                            <div><Button className='close-btn' variant="contained" onClick={close}><CloseIcon style={{ color: '#fad99a' }} /></Button> </div>
                            {jobPanel()}
                        </div>
                    </div>

                </div>
            </Zoom>
        </div>
    );
}

export default JobSelection;